import { LocationOn } from "@mui/icons-material";
import { Autocomplete, Box, InputAdornment, TextField } from "@mui/material";
import { CitiesList } from "app/utils/global_constants";
import { useState } from "react";

function FilterByCity({ value, onChange }) {
  const [inputValue, setInputValue] = useState("");

  return (
    <Autocomplete
      sx={{ flex: 1, minWidth: 300 }}
      freeSolo
      id="city-autocomplete"
      options={CitiesList}
      getOptionLabel={(option) => {
        if (!option) return "";
        if (typeof option === "string") return option;
        return option.label;
      }}
      isOptionEqualToValue={(option, value) => {
        if (!value) return false;
        if (typeof value === "string") return option.label === value;
        return option.label === value.label;
      }}
      filterOptions={(options, { inputValue }) => {
        const input = inputValue.toLowerCase();
        return options.filter((option) => option.label.toLowerCase().includes(input));
      }}
      value={value ? CitiesList.find((city) => city.label === value) || value : null}
      onChange={(event, newValue) => {
        const newCity = typeof newValue === "string" ? newValue : newValue?.label || null;
        onChange(newCity);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue, reason) => {
        setInputValue(newInputValue);
        if (reason === "clear" || newInputValue === "") {
          onChange(null); // or onChange("") depending on your usage
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search by city"
          fullWidth
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {inputValue && (
                  <InputAdornment position="end">
                    {/* <KeyboardReturn sx={{ color: "text.secondary" }} /> */}
                  </InputAdornment>
                )}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props}>
          <Box display="flex" gap={1} alignItems="center">
            <LocationOn sx={{ color: "text.secondary" }} />
            <Box component="span" sx={{ fontWeight: 500 }}>
              {option.label}
            </Box>
          </Box>
        </li>
      )}
      noOptionsText="No matching cities"
    />
  );
}

export default FilterByCity;
